import DetailsDrawer from './components/detailsDrawer/detailsDrawer';
import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { getBrandByDealerNumber } from 'src/utils/helpers';
import { IUser } from 'src/utils/interfaces/user';
import { Portfolio } from 'src/services/models/portfolio.service';
import Search from 'src/views/pages/portfolio-management/components/portfolio_search';
import Spinner from 'src/components/ui/spinner';
import { Table } from './components/table';
import TableFooter from 'src/components/table/pagination/tableFooter';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import {
    AccountStatus,
    PortfolioSearch,
} from 'src/utils/enums/portfolio.enums';
import Notification, {
    NotificationType,
} from 'src/components/ui/notification/Notification';
import { useEffect, useState } from 'react';
import './styles.scss';

const loaderComponent = (
    <div className='loader_container'>
        <Spinner />
    </div>
);

export const PortfolioManagement = () => {
    const { portfolioManager, labelText, portfolioManagerDetails } =
        useLocalization();
    const currentDealers = useSelector((state: IUser) => {
        return state.currentDealers;
    });
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });

    const [error, setError] = useState<boolean>(false);
    const [brand, setBrand] = useState<string>('vw6');
    const [country, setCountry] = useState<string>('');
    const [dealerID, setDealerID] = useState('');
    const [, setSearchFilter] = useState(PortfolioSearch.MONTHS);
    const [, setSearchValue] = useState(Number('3'));
    const [accountFilter, setAccountFilter] = useState(AccountStatus.ACTIVE);
    const [records, setRecords] = useState<Portfolio[]>([]);
    const [displayedContent, setDisplayedContent] = useState<Portfolio[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const [sortType, setSortType] = useState<string>('maturityDate');
    const [sortOrder, setSortOrder] = useState<boolean>(false);
    const [detailAccountNumber, setDetailAccountNumber] = useState<
        string | null
    >(null);

    useEffect(() => {
        if (dealerDataInfo && currentDealers) {
            const { dealer } = dealerDataInfo;
            setBrand(getBrandByDealerNumber(dealer.brand, dealer.dealerNumber));
            setDealerID(dealer.dealerNumber);
            setCountry(dealer.country);
        }
    }, []);

    useEffect(() => {
        if (dealerID && accountFilter) {
            const isTerminated = accountFilter === AccountStatus.TERMINATED;

            if (isTerminated) {
                setSearchFilter(PortfolioSearch.MONTHS);
                setSearchValue(Number('3'));
            }
            setSortType(isTerminated ? 'termStatusDate' : 'maturityDate');
            setSortOrder(false);
        }
    }, [accountFilter]);

    return !!dealerID ? (
        <>
            <div className='portfolio-status-wrapper'>
                {error && (
                    <div className='page-title u-mb-large warning'>
                        <Notification
                            content={''}
                            contentHtml={portfolioManagerDetails.ERROR}
                            type={NotificationType.ERROR}
                            visibility={error}
                            setVisibility={setError}
                        />
                    </div>
                )}
                <div className='page-title'>
                    <h5>{portfolioManager.PORTFOLIO_TITLE_LABEL}</h5>
                </div>
                <div className='search-container'>
                    <Search
                        updateTableContent={setRecords}
                        dealerID={dealerID}
                        setLoading={setLoading}
                        sortType={sortType}
                        sortOrder={sortOrder}
                        brand={brand}
                        country={country}
                        accFilter={accountFilter}
                    />
                </div>
                <div className={'content-container'}>
                    <>
                        <div className='wrapper'>
                            <div className='c-tabs c-tabs--portfolio'>
                                <div className='c-tabs__nav-container'>
                                    <nav aria-label='Tabs Navigation'>
                                        <div className='c-tabs__nav'>
                                            <div className='c-tabs__nav-item'>
                                                <button
                                                    className={`c-tabs__nav-link ${
                                                        accountFilter ===
                                                        AccountStatus.ACTIVE
                                                            ? 'is-active'
                                                            : ''
                                                    }`}
                                                    onClick={() => {
                                                        setAccountFilter(
                                                            AccountStatus.ACTIVE,
                                                        );
                                                    }}
                                                    type='button'
                                                >
                                                    <a
                                                        className='c-link'
                                                        data-testid='link-item-faqs'
                                                    >
                                                        <span className='c-link__body'>
                                                            {
                                                                portfolioManager.PORTFOLIO_ACTIVE_CONTRACTS
                                                            }
                                                        </span>
                                                    </a>
                                                </button>
                                            </div>
                                            <div className='c-tabs__nav-item'>
                                                <button
                                                    className={`c-tabs__nav-link ${
                                                        accountFilter ===
                                                        AccountStatus.TERMINATED
                                                            ? 'is-active'
                                                            : ''
                                                    }`}
                                                    onClick={() => {
                                                        setAccountFilter(
                                                            AccountStatus.TERMINATED,
                                                        );
                                                    }}
                                                    type='button'
                                                >
                                                    <a
                                                        className='c-link'
                                                        data-testid='link-item-message-center'
                                                    >
                                                        <span className='c-link__body'>
                                                            {
                                                                portfolioManager.PORTFOLIO_TERMINATED_CONTRACTS
                                                            }
                                                        </span>
                                                    </a>
                                                </button>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        {!loading ? (
                            records.length ? (
                                <>
                                    <Table
                                        items={displayedContent}
                                        sortType={sortType}
                                        sortOrder={sortOrder}
                                        setSortType={setSortType}
                                        setSortOrder={setSortOrder}
                                        acctFilter={accountFilter}
                                        setDetailAccountNumber={
                                            setDetailAccountNumber
                                        }
                                    />
                                    <TableFooter
                                        brand={brand}
                                        content={records}
                                        setDisplayedContent={
                                            setDisplayedContent
                                        }
                                    />
                                </>
                            ) : (
                                <div className='no-content'>
                                    <div>
                                        {`${labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_NO_RESULTS} `}
                                        <span className='bold'></span>
                                    </div>
                                    <div className='small-text'>
                                        {
                                            labelText.LABEL_TEXT_FUNDING_SEARCH_ERROR_SUGGESTION
                                        }
                                    </div>
                                </div>
                            )
                        ) : (
                            loaderComponent
                        )}
                    </>
                </div>
                <div className='privacy-footer-container '>
                    <FooterPrivacy />
                </div>
            </div>
            <>
                {detailAccountNumber && (
                    <DetailsDrawer
                        dealerId={dealerID}
                        country={country}
                        accountNumber={detailAccountNumber}
                        setError={() => {
                            setError(true);
                        }}
                        close={() => setDetailAccountNumber(null)}
                    />
                )}
            </>
        </>
    ) : null;
};
